import PlanoGoverno from '../../views/public/plano_governo'
import PorSecretaria from '../../views/public/plano_governo/PorSecretaria'
import { DEFAULT_TITLE } from '../const'

export const planoDeGoverno = [
  {
    name: 'planodegoverno',
    path: '/planodegoverno',
    component: PlanoGoverno,
    meta: {
      title: `${DEFAULT_TITLE} | Plano de Governo`
    }
  },
  {
    name: 'planoporsecretaria',
    path: '/planodegoverno/por-secretaria/:secretaria',
    component: PorSecretaria,
    meta: {
      title: `${DEFAULT_TITLE} | Plano de Governo - Por Secretaria`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/planoDeGoverno.js